import CameraIcon from './CameraIcons';

export default function ImagePreview({ imageUrl, file, processing, onRetry, onSubmit }) {
  const size = file ? `${(file.size / 1024 / 1024).toFixed(1)} مگابایت` : '';
  return <section className="plate-preview" aria-label="پیش‌نمایش عکس پلاک">
    <img src={imageUrl} alt="عکس انتخاب‌شده از پلاک خودرو" />
    <div className="plate-preview__meta"><span>عکس آمادهٔ پردازش است</span><small>{size}</small></div>
    <div className="plate-preview__actions">
      <button type="button" className="plate-capture__secondary" onClick={onRetry} disabled={processing}><CameraIcon name="retry" /> عکس مجدد</button>
      <button type="button" className="plate-capture__primary" onClick={onSubmit} disabled={processing}>{processing ? 'در حال خواندن پلاک…' : 'خواندن پلاک و ادامه'}</button>
    </div>
  </section>;
}
